﻿export class VirusDetected {
    static $type = 'SAM.Workflow.Core.ExceptionMessages.VirusDetected, SAM.Workflow.Core';

    constructor(public infectedFiles: InfectedFile) { }
}

export class InfectedFile {
    constructor(public fileName: string, public virusName: string) {}
}